import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Contact = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];
  const isROPage = location.pathname === '/ro';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would send this data to a backend
    const mailtoLink = `mailto:ashishtripathi348@gmail.com?subject=Contact Form Submission&body=Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0APhone: ${formData.phone}%0D%0AMessage: ${formData.message}`;
    window.location.href = mailtoLink;
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const borderColor = isROPage ? 'border-blue-500/50' : 'border-green-500/50';
  const textColor = isROPage ? 'text-blue-400' : 'text-green-400';
  const gradientColor = isROPage ? 'from-blue-400 to-cyan-400' : 'from-green-400 to-cyan-400';
  const gradientLine = isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500';
  const bgPattern = isROPage ? '' : 'security-grid opacity-10';

  return (
    <section id="contact" className={`py-24 ${isROPage ? 'bg-gradient-to-b from-blue-50 via-cyan-50 to-white text-gray-900' : 'bg-gradient-to-b from-gray-900 via-slate-800 to-black text-white'} relative overflow-hidden`}>
      {/* Background Pattern */}
      {!isROPage && <div className={`absolute inset-0 ${bgPattern}`}></div>}
      
      {/* Corner Brackets - only for CCTV */}
      {!isROPage && (
        <>
          <div className={`absolute top-8 left-8 w-16 h-16 border-t-2 border-l-2 ${borderColor}`}></div>
          <div className={`absolute top-8 right-8 w-16 h-16 border-t-2 border-r-2 ${borderColor}`}></div>
        </>
      )}
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className={`inline-block px-6 py-2 ${isROPage ? 'bg-blue-100 border-2 border-blue-400' : 'bg-black/60 border-2 border-green-500/50'} rounded mb-6`}>
            <span className={`${isROPage ? 'text-blue-700' : textColor} font-semibold font-mono text-sm tracking-wider`}>{t.contactBadge}</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-extrabold mb-6 font-mono">
            {t.contactTitle} <span className={`bg-gradient-to-r ${gradientColor} bg-clip-text text-transparent`}>{t.contactTitle2}</span>
          </h2>
          <p className={`text-xl md:text-2xl ${isROPage ? 'text-gray-600' : 'text-gray-400'} max-w-3xl mx-auto font-mono`}>
            {t.contactSubtitle}
          </p>
          <div className={`w-24 h-1 bg-gradient-to-r ${gradientLine} mx-auto mt-6 rounded-full`}></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className={`${isROPage ? 'bg-white' : 'bg-gray-800/80 backdrop-blur-sm'} rounded-lg p-8 shadow-2xl border-2 ${borderColor} transform hover:scale-105 hover:${borderColor.replace('/50', '/60')} transition-all duration-300`}>
              <h3 className={`text-3xl font-bold ${isROPage ? 'text-gray-900' : 'text-white'} mb-8 flex items-center font-mono`}>
                <span className={`w-1 h-8 bg-gradient-to-b ${gradientColor} rounded-full mr-4`}></span>
                {t.contactInfoTitle}
              </h3>
              
              <div className="space-y-6">
                {[
                  {
                    icon: (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    ),
                    title: t.contactPhone,
                    content: '+91 9795200337',
                    link: 'tel:+919795200337',
                    gradient: isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500'
                  },
                  {
                    icon: (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    ),
                    title: t.contactEmail,
                    content: 'ashishtripathi348@gmail.com',
                    link: 'mailto:ashishtripathi348@gmail.com',
                    gradient: isROPage ? 'from-cyan-500 to-blue-500' : 'from-cyan-500 to-green-500'
                  },
                  {
                    icon: (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    ),
                    title: t.contactLocation,
                    content: language === 'en' ? 'Raptinagar, Gorakhpur' : 'राप्तीनगर, गोरखपुर',
                    link: null,
                    gradient: isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-emerald-500'
                  },
                  {
                    icon: (
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                      </svg>
                    ),
                    title: t.contactWebsite,
                    content: 'www.welcome-ro-security-system.com',
                    link: 'https://www.welcome-ro-security-system.com',
                    gradient: isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500'
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-start group">
                    <div className={`bg-gradient-to-br ${item.gradient} rounded-lg p-4 mr-4 shadow-lg ${isROPage ? 'shadow-blue-500/50' : 'shadow-green-500/50'} transform group-hover:scale-110 transition-all duration-300`}>
                      <div className="text-white">
                        {item.icon}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h4 className={`font-bold ${isROPage ? 'text-blue-600' : textColor} mb-1 text-lg font-mono`}>{item.title}</h4>
                      {item.link ? (
                        <a href={item.link} target={item.link.startsWith('http') ? '_blank' : undefined} rel={item.link.startsWith('http') ? 'noopener noreferrer' : undefined} className={`${isROPage ? 'text-gray-600 hover:text-blue-600' : 'text-gray-300 hover:text-green-400'} transition-colors break-all`}>
                          {item.content}
                        </a>
                      ) : (
                        <p className={isROPage ? 'text-gray-600' : 'text-gray-300'}>{item.content}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Business Hours */}
            <div className={`${isROPage ? 'bg-gradient-to-br from-blue-600 to-cyan-600' : 'bg-gradient-to-br from-gray-800 to-black'} rounded-lg p-8 shadow-2xl text-white border-2 ${borderColor}`}>
              <h3 className={`text-2xl font-bold mb-6 flex items-center font-mono`}>
                <svg className={`w-6 h-6 mr-3 ${isROPage ? 'text-blue-200' : textColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {t.contactHours}
              </h3>
              <div className="space-y-4">
                <div className={`flex justify-between items-center ${isROPage ? 'bg-white/10' : 'bg-gray-900/50'} backdrop-blur-sm rounded-lg p-4 border ${borderColor}`}>
                  <span className={`font-semibold ${isROPage ? 'text-blue-100' : 'text-gray-300'}`}>{t.contactMonday}</span>
                  <span className={`font-bold text-lg ${isROPage ? 'text-blue-200' : textColor} font-mono`}>9:00 AM - 7:00 PM</span>
                </div>
                <div className={`flex justify-between items-center ${isROPage ? 'bg-white/10' : 'bg-gray-900/50'} backdrop-blur-sm rounded-lg p-4 border ${borderColor}`}>
                  <span className={`font-semibold ${isROPage ? 'text-blue-100' : 'text-gray-300'}`}>{t.contactSunday}</span>
                  <span className={`font-bold text-lg ${isROPage ? 'text-blue-200' : textColor} font-mono`}>10:00 AM - 5:00 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className={`${isROPage ? 'bg-white' : 'bg-gray-800/80 backdrop-blur-sm'} rounded-lg p-8 md:p-10 shadow-2xl border-2 ${borderColor}`}>
            <h3 className={`text-3xl font-bold ${isROPage ? 'text-gray-900' : 'text-white'} mb-8 flex items-center font-mono`}>
              <span className={`w-1 h-8 bg-gradient-to-b ${gradientColor} rounded-full mr-4`}></span>
              {t.contactFormTitle}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className={`block text-sm font-semibold ${isROPage ? 'text-blue-600' : textColor} mb-2 font-mono`}>
                  {t.contactName}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className={`w-full px-5 py-4 border-2 ${isROPage ? 'border-gray-300 bg-gray-50 text-gray-900 focus:ring-blue-500 focus:border-blue-500' : 'border-gray-700 bg-gray-900 text-white focus:ring-green-500 focus:border-green-500'} rounded-lg focus:ring-2 transition-all placeholder-gray-500`}
                  placeholder={language === 'en' ? 'Your Name' : 'आपका नाम'}
                />
              </div>

              <div>
                <label htmlFor="email" className={`block text-sm font-semibold ${isROPage ? 'text-blue-600' : textColor} mb-2 font-mono`}>
                  {t.contactEmail}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className={`w-full px-5 py-4 border-2 ${isROPage ? 'border-gray-300 bg-gray-50 text-gray-900 focus:ring-blue-500 focus:border-blue-500' : 'border-gray-700 bg-gray-900 text-white focus:ring-green-500 focus:border-green-500'} rounded-lg focus:ring-2 transition-all placeholder-gray-500`}
                  placeholder={t.contactEmailPlaceholder}
                />
              </div>

              <div>
                <label htmlFor="phone" className={`block text-sm font-semibold ${isROPage ? 'text-blue-600' : textColor} mb-2 font-mono`}>
                  {t.contactPhone}
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className={`w-full px-5 py-4 border-2 ${isROPage ? 'border-gray-300 bg-gray-50 text-gray-900 focus:ring-blue-500 focus:border-blue-500' : 'border-gray-700 bg-gray-900 text-white focus:ring-green-500 focus:border-green-500'} rounded-lg focus:ring-2 transition-all placeholder-gray-500`}
                  placeholder={t.contactPhonePlaceholder}
                />
              </div>

              <div>
                <label htmlFor="message" className={`block text-sm font-semibold ${isROPage ? 'text-blue-600' : textColor} mb-2 font-mono`}>
                  {t.contactMessage}
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  className={`w-full px-5 py-4 border-2 ${isROPage ? 'border-gray-300 bg-gray-50 text-gray-900 focus:ring-blue-500 focus:border-blue-500' : 'border-gray-700 bg-gray-900 text-white focus:ring-green-500 focus:border-green-500'} rounded-lg focus:ring-2 transition-all resize-none placeholder-gray-500`}
                  placeholder={t.contactMessagePlaceholder}
                ></textarea>
              </div>

              <button
                type="submit"
                className={`w-full bg-gradient-to-r ${isROPage ? 'from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 shadow-blue-500/50 border-blue-400/50' : 'from-green-600 to-cyan-600 hover:from-green-700 hover:to-cyan-700 shadow-green-500/50 border-green-400/50'} text-white py-4 px-8 rounded-lg font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl border-2 font-mono`}
              >
                {t.contactSubmit}
                <svg className="w-5 h-5 inline-block ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

